import React, { useState } from 'react';
import Lightbox from 'react-18-image-lightbox';
import KovImage from './KovImage';
import 'react-18-image-lightbox/style.css';

const KovImageGroup = ({ item, baseUrl }) => {
  const children = item?.items || item?.children;

  const isEven = (children?.length ?? 0) % 2 === 0;
  const [lightboxIndex, setLightboxIndex] = useState(-1);
  const images = children.map((child) => child.image?.href);

  return (
    <>
      <figure className="kov-image-group">
        <div className="media-wrapper photo clearfix">
          <div className="photo-gallery row">
            {children?.map((image, i) => (
              <span key={i} className={`col-12 ${isEven ? 'col-sm-6' : 'col-sm-4'}`}>
                <KovImage
                  item={image}
                  baseUrl={baseUrl}
                  onClick={() => {
                    setLightboxIndex(i);
                  }}
                  isImageGroup={true}
                />
              </span>
            ))}
          </div>
        </div>
      </figure>
      {lightboxIndex !== -1 && (
        <Lightbox
          mainSrc={images[lightboxIndex]}
          nextSrc={images[(lightboxIndex + 1) % images.length]}
          prevSrc={images[(lightboxIndex + images.length - 1) % images.length]}
          onMovePrevRequest={() =>
            setLightboxIndex((lightboxIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() => setLightboxIndex((lightboxIndex + 1) % images.length)}
          onCloseRequest={() => setLightboxIndex(-1)}
        />
      )}
    </>
  );
};

export default KovImageGroup;
